module.exports = __webpack_public_path__ + "static/img/vipbgimg.79fe9d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/header/img/vipbgimg.png
// module id = uefZ
// module chunks = 2